import { FC, useState } from "react"
import { PuxButton, PuxDialogTitle, PuxText, useTranslation } from "@phonero/pux-react"
import { AddSimCardInput, ApiProductState, OrderSimCardInput, SimCardAddressInput, SimCardType2 } from "@phonero/common-graphql/types"
import { SimCardClassification, SimCardFragment, SimCardProductFragment, SimCardType, useSteps } from "@phonero/common-ux"
import { AddressStep } from "./AddressStep"
import { ConfirmStep } from "./ConfirmStep"
import { SimCardOrderFragment } from "@phonero/common-ux"
// import {
//   SimCardFragment,
//   SimCardProductFragment,
// } from "pages/SubscriptionDetails/AvailableAndActiveSimCards.generated"
// import { ApiProductState, SimCardAddressInput } from "graphqlTypes"
// import useSteps from "../../../../../common/src/Wizards/useSteps"
// import { AddressStep, Data } from "./AddressStep"
// import { ConfirmStep } from "./ConfirmStep"
// import { SimCardClassification } from "../../../../../common/src/SimCard/types"
export interface ISimCardWizardProps {
  subscriptionId: string
  enableSimWithoutPin: boolean
  cardType: SimCardType2
  // Existing card if replaced
  card?: SimCardProductFragment | SimCardFragment | SimCardOrderFragment
  // Available card products with different paymentType
  cards?: (SimCardProductFragment | SimCardFragment | SimCardOrderFragment)[]
  address: SimCardAddressInput
  onClose?: () => void
  userName?: string
  msisdn?: string
}
export type Data = (OrderSimCardInput | AddSimCardInput) & {cardType: SimCardType2}
export const SimCardWizard: FC<ISimCardWizardProps> = ({
  subscriptionId,
  enableSimWithoutPin,
  cardType,
  card,
  cards,
  address,
  onClose,
  userName,
  msisdn,
}) => {
  const [data, setData] = useState<Data>({
    address,
    subscriptionId,
    cardType: cardType,
  })
  const [deliveryMethod, setDeliveryMethod] = useState<number | undefined>(0)
  const [simWithoutPin, setSimWithoutPin] = useState<boolean>(false)
  const { t } = useTranslation()
  const { step, onNext, onPrev } = useSteps({ maxSteps: 2 })
  const [simCardClassification, setSimCardClassification] = useState<SimCardClassification | undefined>(
    SimCardClassification.Nano
  )
  const [embeddedSimEmail, setEmbeddedSimEmail] = useState<string | undefined>()
  return (
    <>
      <PuxDialogTitle onBackClick={onPrev} withBackButton={true}>
        <PuxText style={{ fontSize: "2.6rem", fontWeight: 900 }}>
          {card?.state === ApiProductState.Active ? "Erstatt" : "Bestill"} {t("SimCard.Type", { context: cardType })}
        </PuxText>
      </PuxDialogTitle>
      {step === 0 && (
        <AddressStep
          onNext={onNext}
          address={address}
          data={data}
          setData={setData}
          card={card}
          enableSimWithoutPin={enableSimWithoutPin}
          simWithoutPin={simWithoutPin}
          setSimWithoutPin={setSimWithoutPin}
          deliveryMethod={deliveryMethod}
          setDeliveryMethod={setDeliveryMethod}
          simCardClassification={simCardClassification}
          setSimCardClassification={setSimCardClassification}
          embeddedSimEmail={embeddedSimEmail}
          setEmbeddedSimEmail={setEmbeddedSimEmail}
        />
      )}
      {step === 1 && (
        <ConfirmStep
          data={data}
          onNext={onNext}
          subscriptionId={subscriptionId}
          address={address}
          sendSimcard={deliveryMethod !== 1}
          card={card}
          cards={cards}
          simWithoutPin={simWithoutPin}
          onClose={onClose}
          userName={userName}
          msisdn={msisdn}
          embeddedSim={simCardClassification === SimCardClassification.Embedded}
          embeddedSimEmail={embeddedSimEmail}
        />
      )}
    </>
  )
}
